<template>
  <div class="d-flex">
    <span class="flex-grow-0">Skin testen:</span>
    <select class="flex-grow-1 ms-2" @change="applySkin($event, $page.props.admin_request)">
      <option v-if="!$page.props.user.skins.includes($page.props.skin)" :value="$page.props.skin" selected>
        {{ $page.props.skin }}
      </option>
      <option v-for="skin in $page.props.user.skins" :key="skin" :value="skin" :selected="$page.props.skin === skin">
        {{ skin }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  emits: [],
  setup() {
    const applySkin = async (event, adminRequest) => {
      let settingKey = adminRequest ? 'admin_skin' : 'skin';

      window.location = `/user-settings/apply/${settingKey}/${event.target.value}`;
    };

    return {
      applySkin,
    };
  },
};
</script>
